import React, { useState, useEffect } from 'react';
import { PenLine, Save, Check } from 'lucide-react';
import { toast } from 'sonner';

export const JournalPrompt = ({ question, chapterId, questionIndex }) => {
  const storageKey = `journal-ch${chapterId}-q${questionIndex}`;
  const [response, setResponse] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const savedResponse = localStorage.getItem(storageKey);
    if (savedResponse) {
      setResponse(savedResponse);
      setSaved(true);
    }
  }, [storageKey]);

  const handleSave = () => {
    localStorage.setItem(storageKey, response);
    setSaved(true);
    toast.success('Your reflection has been saved', {
      description: 'Your words are safely stored on this device.',
    });
  };

  const handleChange = (e) => {
    setResponse(e.target.value);
    setSaved(false);
  };

  return (
    <div 
      data-testid={`journal-prompt-${questionIndex}`}
      className="my-8 p-6 bg-white rounded-xl border border-stone-100 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_12px_rgba(0,0,0,0.06)] transition-all animate-fade-in"
    >
      <div className="flex items-start gap-3 mb-4">
        <div className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0 mt-1">
          <PenLine className="w-4 h-4 text-gold" />
        </div>
        <p className="font-body text-charcoal font-medium leading-relaxed">
          {question}
        </p>
      </div>
      <div className="ml-11">
        <textarea
          data-testid={`journal-input-${questionIndex}`}
          value={response}
          onChange={handleChange}
          placeholder="Write your reflection here..."
          className="w-full min-h-[120px] bg-cream-paper border-none focus:ring-2 focus:ring-sage/30 rounded-lg p-4 text-charcoal placeholder:text-charcoal-light/50 resize-none shadow-inner font-body leading-relaxed"
        />
        <div className="flex justify-end mt-3">
          <button
            data-testid={`journal-save-${questionIndex}`}
            onClick={handleSave}
            className={`flex items-center gap-2 px-5 py-2 rounded-full text-sm font-medium transition-all ${
              saved 
                ? 'bg-sage/20 text-sage' 
                : 'bg-sage text-white hover:bg-sage-dark'
            }`}
          >
            {saved ? (
              <>
                <Check className="w-4 h-4" />
                Saved
              </>
            ) : (
              <>
                <Save className="w-4 h-4" />
                Save Reflection
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
